export enum NotificationEventType {
  LIVE_CLASS_SURVEY = 'LiveClassSurveyNotification',
  TEACHER_FEEDBACK = 'TeacherFeedbackNotification',
  GENERIC_POPUP = 'GenericPopupNotification',
  NEW_LEVEL_CONGRATULATION = 'NewLevelCongratulationNotification',
  MID_LEVEL_TEST = 'MidLevelTestNotification',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/notification-event-type.ts